import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { TranslateModule } from "@ngx-translate/core";
import { PipesModule } from "src/app/common/pipes/pipes.module";
import { ButtonToggleModule } from "../../button-toggle/button-toggle.module";
import { ContentfulMediaComponent } from "../../contentful-media/contentful-media.component";
import { DialogFrameModule } from "../../dialog-frame/dialog-frame.module";
import { CheckboxModule } from "../../form/checkbox/checkbox.module";
import { InputFieldModule } from "../../form/input-field/input-field.module";
import { TextareaFieldModule } from "../../form/textarea-field/textarea-field.module";
import { MediaPlayerModule } from "../../media-player/media-player.module";
import { LeadComponent } from "./lead.component";
import { LeadService } from "./lead.service";
const materialModules = [
  MatDialogModule,
  MatCheckboxModule,
  MatIconModule,
  MatRadioModule,
  MatInputModule,
  MatFormFieldModule
];

@NgModule({
  declarations: [LeadComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PipesModule,
    ButtonToggleModule,
    InputFieldModule,
    TextareaFieldModule,
    CheckboxModule,
    MediaPlayerModule,
    DialogFrameModule,
    ContentfulMediaComponent,
    ...materialModules
  ],
  providers: [LeadService]
})
export class LeadModule {}
